export default __webpack_public_path__ + "static/media/testimonials@3x.02802615.png";